import { useState, useEffect, RefObject } from 'react';

interface SectionRef {
  id: string;
  ref: RefObject<HTMLElement | null>;
}

export const useVisibleSection = (sectionRefs: SectionRef[]) => {
  const [visibleSection, setVisibleSection] = useState<string>('');

  useEffect(() => {
    if (!sectionRefs.length) return;

    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200; // buffer to account for scrollTo behavior

      // Find the section that's currently in view
      for (const { id, ref } of sectionRefs) {
        const element = ref.current;
        if (!element) continue;

        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;
        const elementBottom = elementTop + rect.height;

        if (scrollPosition >= elementTop && scrollPosition <= elementBottom) {
          setVisibleSection(id);
          break;
        }
      }
    };

    // Initial check
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [sectionRefs]);

  return visibleSection;
};
